import SlidePresentation from '@/components/SlidePresentation';

const Index = () => {
  return <SlidePresentation />;
};

export default Index;